import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const CouponsAPI = createApi({
    reducerPath: "CouponsAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders:  (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");

            // Apply JSON content-type except for multipart endpoints
            if (!["addCoupons", "updateCoupon", "updateCouponStatus"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        addCoupons: builder.mutation({
            query: (formData) => ({
                url: "admin/coupons",
                method: "POST",
                body: formData,
            }),
        }),
        updateCoupon: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/coupons/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getCouponList: builder.query({
            query: () => `admin/coupons`,
        }),

        getCouponbyId: builder.query({
            query: (id) => `admin/coupons/${id}`,
        }),


        deleteCoupon: builder.mutation({
            query: (id) => ({
                url: `admin/coupons/${id}`,
                method: "DELETE",
            }),
        }),

        updateCouponStatus: builder.mutation({
            query: (formData) => ({
                url: `admin/update-coupon-status`,
                method: "POST",
                body: formData,
            }),
        }),


    }),
});

export const { useAddCouponsMutation, useGetCouponListQuery, useGetCouponbyIdQuery, useDeleteCouponMutation, useUpdateCouponMutation, useUpdateCouponStatusMutation } = CouponsAPI;
